<template>
  <pop :titledata="datainfo.panelName" :styledata="datainfo.styledata">
    <component v-bind:is="datainfo.componentname"  :datainfo="datainfo"> </component>
  </pop>
</template>

<script>
import pop from "./pop2.vue";
import iodi from "../data/iodi.vue";
import pcs from "../data/pcs.vue";
import wendushidu from "../data/wendushidu.vue";
import kongtiao from "../data/kongtiao.vue";
import bms from "../data/bms.vue";
import cu from "../data/cu.vue";
import cuwarning from "../data/cuwarning.vue";

export default {
  name: "datapop",
  components: {
    pop,
    iodi,
    pcs,
    wendushidu,
    kongtiao,
    bms,cuwarning,cu
  },
  props: ["datainfo"],
  mounted(){
  },
  computed:{
  }
};
</script>

<style lang="scss" scoped>
#mouseoverpop {
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  font-size: 0.05rem;
  color: #4de7ff;
  z-index: 999;
  transition: 300ms;
  padding: 0.03rem 0.1rem;
  border: 0.02rem solid #4de7ff;
  border-radius: 0.1rem;
  transition: 300ms;
  cursor: pointer;
}
.wrap {
  position: absolute;
  width: 10rem;
  height: 100%;
  overflow: hidden;
  left: 0vw;
  top: 0vh;
  z-index: 9;
  background: linear-gradient(rgb(90, 29, 29), #000);
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/pop/datapop.vue